import React from 'react';
import StatsColumn from '../StatsColumn';
import {STATS_BY_STATUS, STATS_BY_TYPE, STATS_BY_BUYER_STATE} from '../../consts/queries';
import InfoColumns from './InfoColumns';
import VariableChart from '../VariableChart';
import PieChart from '../PieChart';
import {StatsData} from './models/stats';
import {executeQuery} from "../../requests/executeQuery";
import {chartDefaultColors} from "../../chartDefaultColors";
import {calculateTotalColumn} from "../../utils";

const cloneDeep = require('lodash.clonedeep');
const variableChartData = [{
    name: 'STNL',
    y: 0,
    z: 1,
    color: '#A7A9AC',
}, {
    name: 'MT',
    y: 0,
    z: 5,
    color: '#A0D967',
}];

export default class Stats extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stats: new StatsData({}),
            totalClosedSum: null,
            totalClosedCount: null,
            listedChartData: cloneDeep(variableChartData),
            soldChartData: cloneDeep(variableChartData),
            buyerStateYtdChartData: [],
            buyerStateChartData: [],
            buyerStateYtdTotal: 0,
            buyerStateTotal: 0,
            isYtdClosing: true,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    static buildBuyerStateChartData(data) {
        const chartOptionsData = [];
        let index = 0, otherPercentage = 0, otherCount = 0, total = 0;

        if (data && data.length) {
            const totalProperties = calculateTotalColumn(data, 'TOTAL_PROPERTIES');

            data.forEach((row, rowIndex) => {
                if (rowIndex < 3) {
                    total += parseInt(row.TOTAL_PROPERTIES);
                    chartOptionsData.push({
                        name: row.COMPANY_STATE,
                        y: parseInt(row.TOTAL_PROPERTIES),
                        color: chartDefaultColors[index++]
                    });
                } else {
                    total += parseInt(row.TOTAL_PROPERTIES);
                    const percentage = row.TOTAL_PROPERTIES / totalProperties * 100;
                    row.PERCENTAGE = percentage ? percentage.toFixed(2) : 0;
                    otherPercentage += parseFloat(row.PERCENTAGE);
                    otherCount += parseInt(row.TOTAL_PROPERTIES);
                }
            });

            if (otherPercentage && otherCount) {
                chartOptionsData.push({
                    name: 'Other',
                    y: otherCount,
                    color: chartDefaultColors[index]
                });
            }
        }

        return {chartOptionsData, total};
    }

    handleChange(e) {
        this.setState({source: e.currentTarget.value});
    }

    fetch() {
        const ytd = new Date().getFullYear();
        const firstDayOfYtd = `${ytd}-01-01`;
        const firstDayPriorYtd = `${ytd - 1}-01-01`;
        const sinceDate = `${ytd - 2}-01-01`; // since 2 years ago

        Promise.all([
            executeQuery({queryName: STATS_BY_STATUS, params: {SINCE: sinceDate}}),
            executeQuery({queryName: STATS_BY_TYPE, params: {}}),
            executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: firstDayOfYtd}}),
            executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: firstDayPriorYtd}}),
            executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: sinceDate}}),
        ]).then((res) => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data) &&
                res[3] && res[3].success && Array.isArray(res[3].data) &&
                res[4] && res[4].success && Array.isArray(res[4].data)) {
                const stats = new StatsData({
                    dataByStatus: res[0].data[0],
                    dataByType: res[1].data[0],
                });

                const isYtdClosing = !(res[0].data[0] && res[0].data[0].CLOSED_YTD_PROPERTIES && parseInt(res[0].data[0].CLOSED_YTD_PROPERTIES) < 7);

                const {listedChartData, soldChartData} = cloneDeep(this.state);
                listedChartData[0].y = stats.activeStnlCount;
                listedChartData[1].y = stats.activeMtCount;
                soldChartData[0].y = stats.closedStnlCount;
                soldChartData[1].y = stats.closedMtCount;

                let sum = res[1].data[0].CLOSED_PRICE;
                let count = res[1].data[0].CLOSED_COUNT;
                sum = (sum / Math.pow(10, 9)).toString();
                sum = sum.slice(0, sum.indexOf('.') + 2);
                count = parseInt(count / 25) * 25;


                let chartData = Stats.buildBuyerStateChartData(isYtdClosing ? res[2].data : res[3].data);
                const buyerStateYtdChartData = chartData.chartOptionsData;
                const buyerStateYtdTotal = chartData.total;
                chartData = Stats.buildBuyerStateChartData(res[4].data);
                const buyerStateChartData = chartData.chartOptionsData;
                const buyerStateTotal = chartData.total;

                this.setState({
                    stats,
                    listedChartData,
                    soldChartData,
                    totalClosedSum: sum,
                    totalClosedCount: count,
                    buyerStateYtdChartData,
                    buyerStateChartData,
                    buyerStateYtdTotal,
                    buyerStateTotal,
                    isYtdClosing,
                });
            }
        });
    }

    componentDidMount() {
        this.fetch();
    }

    render() {
        const {stats, listedChartData, soldChartData, buyerStateYtdChartData, buyerStateChartData,
            buyerStateYtdTotal, buyerStateTotal, totalClosedCount, totalClosedSum, isYtdClosing} = this.state;
        const ytd = new Date().getFullYear();

        return (
            <div className='Stats'>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container'>
                        <div className='page-header'>
                            <div className='page-title'>Stats</div>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='stats-container page-body-container'>
                    <div className='stats-columns'>
                        <div className='stats-column first'>
                            <InfoColumns title={`Closings - ${isYtdClosing ?  'YTD' : ytd - 1}`}
                                         columns={[
                                             {key: 'Transactions', value: stats.closedYtdCount},
                                             {key: 'Total Value', value: stats.closedYtdPrice},
                                             {key: 'Ave Cap Rate', value: stats.closedYtdAvgCapRate},
                                             {key: 'List:Close Price', value: stats.listClosedPrice},
                                             {key: 'List:Close Time', value: stats.listClosedTime},
                                         ]}
                            />
                            <div className='line'/>
                            <InfoColumns title='Current Inventory'
                                         columns={[
                                             {key: 'Properties', value: stats.activeCount},
                                             {key: 'Total Value', value: stats.activePrice},
                                             {key: 'Ave Cap Rate', value: stats.activeAvgCapRate},
                                             {key: 'Total Sq Ft', value: stats.activeSqft},
                                             {key: 'Ave Time On Market', value: stats.activeAvgTimeOnMarket},
                                         ]}
                            />
                            <div className='line'/>
                            <div className='stats-title'>Buyer State Breakdown</div>
                            <div className='stats-charts'>
                                <PieChart title={isYtdClosing ? `YTD - ${ytd}` : `Closed - ${ytd - 1}`}
                                          total={buyerStateYtdTotal}
                                          data={buyerStateYtdChartData}
                                />
                                <PieChart title={`Closed since ${ytd - 2}`}
                                          total={buyerStateTotal}
                                          data={buyerStateChartData}
                                />
                            </div>
                            <div className='line pie-chart-margin'/>
                            <div className='banner-container'>
                                <div className='stats-title margin-bottom'>#1 INVESTMENT TEAM IN THE SOUTHWEST</div>
                                {totalClosedCount}+ TRANSACTIONS | OVER ${totalClosedSum} BILLION SOLD
                            </div>
                        </div>

                        <div className='stats-column last'>
                            <div className='stats-charts'>
                                <VariableChart title='Listed Properties'
                                               total={stats.activeCount}
                                               data={listedChartData}
                                />
                                <VariableChart title='Sold Properties'
                                               total={stats.closedCount}
                                               data={soldChartData}
                                />
                            </div>
                            <div className='line variable-chart-margin'/>
                            <InfoColumns title='Total Under Contract/In Negotiation'
                                         columns={[
                                             {key: 'Properties', value: stats.negUcCount},
                                             {key: 'Total Value', value: stats.negUcPrice},
                                             {key: 'Total Sq Ft', value: stats.negUcSqft},
                                             {key: 'Ave Cap Rate', value: stats.negUcAvgCapRate},
                                         ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Closed Since ${ytd - 2}`}
                                         columns={[
                                             {key: 'Transactions', value: stats.closedSinceCount},
                                             {key: 'Total Value', value: stats.closedSincePrice},
                                             {key: 'Total Sq Ft', value: stats.closedSinceSqft},
                                             {key: 'Ave Cap Rate', value: stats.closedSinceAvgCapRate},
                                         ]}
                            />
                            <div className='line'/>
                            <InfoColumns title='STRIVE Closings'
                                         columns={[
                                             {key: 'Transactions', value: stats.closedIsCount},
                                             {key: 'Total Value', value: stats.closedIsPrice},
                                             {key: 'Total Sq Ft', value: stats.closedIsSqft},
                                             {key: 'Ave Cap Rate', value: stats.closedIsAvgCapRate},
                                         ]}
                            />
                        </div>
                    </div>

                    <div className='line'/>

                    <div className='stats-tables-container'>
                        <StatsColumn keyword='Listed'
                                     status='Active'
                                     order='LISTED_DATE'
                                     price='LIST_PRICE'
                                     source='STRIVE'
                        />
                        <StatsColumn keyword='Sold'
                                     status='Closed'
                                     order='CLOSE_OF_ESCROW'
                                     price='SOLD_PRICE'
                                     source='STRIVE'
                        />
                    </div>
                </div>
            </div>
        );
    }
}
